import { render, staticRenderFns } from "./CustomField.vue?vue&type=template&id=1ab8e74d&scoped=true&"
import script from "./CustomField.vue?vue&type=script&lang=js&"
export * from "./CustomField.vue?vue&type=script&lang=js&"
import style0 from "./CustomField.vue?vue&type=style&index=0&id=1ab8e74d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab8e74d",
  null
  
)

export default component.exports